import Vue from 'vue';

const DEFAULT_OPTIONS = Object.freeze({
  title: 'Information',
  message: '',
  tone: 'info',
  confirmText: 'OK',
  cancelText: 'Cancel',
  showCancel: false,
  closeOnBackdrop: true,
});

const state = Vue.observable({
  open: false,
  title: DEFAULT_OPTIONS.title,
  message: DEFAULT_OPTIONS.message,
  tone: DEFAULT_OPTIONS.tone,
  confirmText: DEFAULT_OPTIONS.confirmText,
  cancelText: DEFAULT_OPTIONS.cancelText,
  showCancel: DEFAULT_OPTIONS.showCancel,
  closeOnBackdrop: DEFAULT_OPTIONS.closeOnBackdrop,
  _resolver: null,
});

function resetState() {
  state.open = false;
  state.title = DEFAULT_OPTIONS.title;
  state.message = DEFAULT_OPTIONS.message;
  state.tone = DEFAULT_OPTIONS.tone;
  state.confirmText = DEFAULT_OPTIONS.confirmText;
  state.cancelText = DEFAULT_OPTIONS.cancelText;
  state.showCancel = DEFAULT_OPTIONS.showCancel;
  state.closeOnBackdrop = DEFAULT_OPTIONS.closeOnBackdrop;
  state._resolver = null;
}

function resolveAndClose(value) {
  const resolver = state._resolver;
  resetState();
  if (resolver) {
    resolver(value);
  }
}

function openDialog(options = {}) {
  if (state.open && state._resolver) {
    state._resolver(false);
  }

  state.open = true;
  state.title = options.title || DEFAULT_OPTIONS.title;
  state.message = options.message || DEFAULT_OPTIONS.message;
  state.tone = options.tone || DEFAULT_OPTIONS.tone;
  state.confirmText = options.confirmText || DEFAULT_OPTIONS.confirmText;
  state.cancelText = options.cancelText || DEFAULT_OPTIONS.cancelText;
  state.showCancel = !!options.showCancel;
  state.closeOnBackdrop = options.closeOnBackdrop !== false;

  return new Promise((resolve) => {
    state._resolver = resolve;
  });
}

const DialogService = {
  state,
  confirm(options = {}) {
    return openDialog({
      ...options,
      tone: options.tone || 'warning',
      showCancel: true,
      confirmText: options.confirmText || 'Confirm',
      cancelText: options.cancelText || 'Cancel',
    });
  },
  info(options = {}) {
    return openDialog({
      ...options,
      tone: options.tone || 'info',
      confirmText: options.confirmText || 'OK',
    });
  },
  success(options = {}) {
    return openDialog({
      ...options,
      tone: 'success',
      confirmText: options.confirmText || 'OK',
    });
  },
  warning(options = {}) {
    return openDialog({
      ...options,
      tone: 'warning',
      confirmText: options.confirmText || 'OK',
    });
  },
  error(options = {}) {
    return openDialog({
      ...options,
      tone: 'danger',
      confirmText: options.confirmText || 'OK',
    });
  },
  close(value = false) {
    resolveAndClose(value);
  },
};

export default DialogService;
